import "./BecomeOperator.module.css";
import ToppmenyOchKontakt from "@/reusable_sections/Header";
import DrivDinEgenFlotta from "./sections/DrivDinEgenFlotta";
import SupplierForm from "./sections/SupplierForm";
import Footer from "@/reusable_sections/Footer";
export default function BecomeOperatorPage() {
  return <div>
      <ToppmenyOchKontakt />
      <DrivDinEgenFlotta />
      <SupplierForm />
      <Footer />
    </div>;
}